import React from 'react'

import Layout from 'Layout/Layout'

export default function Main() {
  return <Layout header footer />
}
